import * as React from 'react';
import Stack from '@mui/material/Stack';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import InventoryIcon from '@mui/icons-material/Inventory';
import SpeedIcon from '@mui/icons-material/Speed';
import LoginLogout from "./LoginLogout"

class Landing extends React.Component {
    constructor(props) {
        super(props);
        this.state = { };
    }

    loginSuccess = (login_id_token) => {
        this.props.onLoginCallback(login_id_token);
    }

    logoutSuccess = () => {
        this.props.onLogoutCallback();
    }

    render() {
        return  <Stack spacing={4} alignItems="center" justifyContent="center" sx={{ maxWidth: '600px', mx: 'auto', px: 2 }}>
                    {/* Hero Section */}
                    <Box sx={{ textAlign: 'center', pt: 4 }}>
                        <Typography variant="h4" color="primary.main" gutterBottom sx={{ fontWeight: 700 }}>
                            Pattern Bin
                        </Typography>
                        <Typography variant="h6" color="text.secondary" sx={{ mb: 3, fontWeight: 400 }}>
                            Never buy the same sewing pattern twice
                        </Typography>
                    </Box>

                    {/* Main Card */}
                    <Paper sx={{ p: 4, width: '100%', textAlign: 'center' }}>
                        <Stack spacing={3} alignItems="center">
                            {/* Icon */}
                            <Box 
                                sx={{ 
                                    width: 80, 
                                    height: 80, 
                                    borderRadius: '50%', 
                                    bgcolor: 'primary.main',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    mb: 2
                                }}
                            >
                                <InventoryIcon sx={{ fontSize: 40, color: 'white' }} />
                            </Box>

                            <Typography variant="body1" color="text.primary" sx={{ lineHeight: 1.8 }}>
                                Standing in the fabric store wondering if you already have that pattern at home? 
                                Pattern Bin helps you scan barcodes and instantly check your collection.
                            </Typography>

                            <LoginLogout onLoginSuccessCallback={this.loginSuccess} onLogoutSuccessCallback={this.logoutSuccess} loggedIn={false} />
                        </Stack>
                    </Paper>

                    {/* Features */}
                    <Stack spacing={2} sx={{ width: '100%' }}>
                        <FeatureItem 
                            icon={<CameraAltIcon />}
                            title="Quick Scan"
                            description="Point your camera at any pattern barcode"
                        />
                        <FeatureItem 
                            icon={<SpeedIcon />}
                            title="Instant Results"
                            description="Know if you own it in seconds"
                        />
                        <FeatureItem 
                            icon={<CheckCircleIcon />}
                            title="Never Forget"
                            description="Keep track of your entire collection"
                        />
                    </Stack>

                    {/* Footer Text */}
                    <Typography variant="caption" color="text.secondary" sx={{ pb: 4, textAlign: 'center' }}>
                        Free to use • Works on mobile • Privacy focused
                    </Typography>
                </Stack>
  }
}

// Feature Item Component
function FeatureItem({ icon, title, description }) {
    return (
        <Paper sx={{ p: 2.5, display: 'flex', alignItems: 'center', gap: 2 }}>
            <Box 
                sx={{ 
                    width: 48, 
                    height: 48, 
                    borderRadius: 2, 
                    bgcolor: 'primary.light',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                    color: 'white'
                }}
            >
                {icon}
            </Box>
            <Box sx={{ flex: 1 }}>
                <Typography variant="subtitle1" color="text.primary" sx={{ fontWeight: 600, mb: 0.5 }}>
                    {title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    {description}
                </Typography>
            </Box>
        </Paper>
    );
}

export default Landing